import { render } from "./dynamic-form.vue?vue&type=template&id=40e3ee27&ts=true"
import script from "./dynamic-form.vue?vue&type=script&lang=ts"
export * from "./dynamic-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__